import * as React from "react";
import type { SVGProps } from "react";
const SvgBarChartSquareUp011 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.6 15.6 7.45 12l2.75 2.571 6.05-5.657M12.132 8.4H16.8v4.364M4.8 21.6a2.4 2.4 0 0 1-2.4-2.4V4.8a2.4 2.4 0 0 1 2.4-2.4h14.4a2.4 2.4 0 0 1 2.4 2.4v14.4a2.4 2.4 0 0 1-2.4 2.4z"
    />
  </svg>
);
export default SvgBarChartSquareUp011;
